import { render } from "./PropertyCheck.vue?vue&type=template&id=3a6f220c&scoped=true"
import script from "./PropertyCheck.vue?vue&type=script&lang=js"
export * from "./PropertyCheck.vue?vue&type=script&lang=js"

import "./PropertyCheck.vue?vue&type=style&index=0&id=3a6f220c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6f220c"]])

export default __exports__